export const SET_OVERVIEW_TABLES = "OVERVIEW_TABLES > SET_OVERVIEW_TABLES";
export const SET_LOADING_OVERVIEW_TABLES = "OVERVIEW_TABLES > SET_LOADING";
export const SET_OVERVIEW_TABLES_FILTER = "OVERVIEW_TABLES > SET_FILTER";
export const DELETE_OVERVIEW_TABLES_FILTER = "OVERVIEW_TABLES > DELETE_FILTER";
